import React, { useCallback, useEffect } from "react";
import { injectIntl } from "react-intl";
import {
  DocumentCard,
  DocumentCardImage,
  ImageFit,
  DocumentCardTitle,
  classNamesFunction,
} from "@fluentui/react";
import { InjectedIntlProps } from "react-intl";
import { withRouter } from "react-router-dom";
import { RouteComponentProps } from "react-router";
import { messages } from "./Help.messages";
import quickStart from "../../images/QSG22.svg";
import milestoneUploadFeature from "../../images/MUP22.svg";
import supplierCollab from "../../images/supplierCollab.png";
import applicationWalkthrough from "../../images/applicationWalkthrough.png";
import globalEcifWalkthrough from "../../images/globalEcifWalkthrough.svg";
import { useSelector } from "react-redux";
import { getCurrentTheme } from "../../../core/store";
import { getStyles } from "./Help.styles";
import useCustomLogService from '../../services/useCustomLogService';


interface OwnProps extends InjectedIntlProps {
  isAppReady: boolean;
}

type Props = OwnProps & RouteComponentProps;
let classes: any;
const getClassNames = classNamesFunction<any, any>();
const HelpComponent: React.FC<Props> = (props) => {
  const { intl } = props;
  const theme = useSelector(getCurrentTheme);
  classes = getClassNames(getStyles, theme);

  const { trackCustomEvents } = useCustomLogService();

  const trackHelpVideosOptionClicks = useCallback((option: string, optionTitle: string, optionLink: string) => {
      trackCustomEvents(`ECIFWorkscopePortal.HelpVideos.${option}`,  `${optionTitle} Link Clicked`, 'Success', { 
          link: optionLink
      });
  }, [trackCustomEvents]);

  useEffect(() => {
    // Placeholder
    // eslint-disable-next-line
    trackCustomEvents(`ECIFWorkscopePortal.HelpVideos`,  `HelpVideos panel opened`, 'Success');
    return () => {
      trackCustomEvents(`ECIFWorkscopePortal.HelpVideos`,  `HelpVideos panel closed`, 'Success');
    }
  }, []);

  const renderMain = (): JSX.Element => {
    const videoLinks = [
      {key: "quickStart1", href: "https://aka.ms/ecifwsQSG", img: quickStart, text: intl.formatMessage(messages.quickStartGuide)},
      {key: "quickStart2", href: "https://aka.ms/ecifwsImpExguide", img: milestoneUploadFeature, text: intl.formatMessage(messages.milestoneUploadFeature)},
      {key: "quickStart3", href: "https://aka.ms/supplierhelpvideo", img: supplierCollab, text: intl.formatMessage(messages.supplierCollaboration)},
      {key: "quickStart4", href: "http://aka.ms/applicationwalkthrough", img: applicationWalkthrough, text: intl.formatMessage(messages.applicationwalkthrough)},
      {key: "quickStart5", href: "https://aka.ms/ECIFQualityService", img: "/images/ECIFQualityService.png", text: intl.formatMessage(messages.ECIFQualityService)},

      // {key: "quickStart5", href: "https://aka.ms/GlobalEcifWalkthrough", img: globalEcifWalkthrough, text: intl.formatMessage(messages.globalEcifWalkthrough)},
    ]
    return (
      <div>
        <p className={classes.paraStyles}>
          {intl.formatMessage(messages.helpSubtext)}
        </p>
        {/* <p className={classes.paraStyles}>
          {intl.formatMessage(messages.helpParaLinkInfo)}{" "}
          <span>
            <Link
              className={classes.linkStyles}
              target="_blank"
              href="https://aka.ms/ecifworkscope"
            >
              {intl.formatMessage(messages.linkHereText)}
            </Link>
          </span>
        </p> */}
        <div className={classes.cardGroupStyle}>
          {videoLinks.map((item) => (
            <DocumentCard
              onClickHref={item.href}
              onClickTarget="_blank"
              className={classes.cardStyles}
              key={item.key}
              onClick={() => trackHelpVideosOptionClicks(item.key, item.text, item.href)}
            >
              <DocumentCardImage
                className={classes.imageStyles}
                imageFit={ImageFit.cover}
                imageSrc={item.img}
              />
              <DocumentCardTitle
                title={item.text}
                className={classes.titleStyle}
              />
              
            </DocumentCard>
          ))}
        </div>
      </div>
    );
  };

  return renderMain();
};
export const Help = withRouter(injectIntl(HelpComponent));

// Generated by GitHub Copilot | Updated on: 2026-05-26 | 3 lines modified | Fixed Help image path to public asset
